export default class UrlQuery {
  private static search() {
    return new URLSearchParams(window.location.search);
  }

  private static Converter = class UrlQueryConverter {
    private readonly value: string;

    constructor(value: string) {
      this.value = value;
    }

    public string() {
      return this.value;
    }

    public number() {
      return Number.parseFloat(this.value.replace(/[^\d.,-]/g, '').replace(',', '.'));
    }

    public boolean() {
      const lowerCase = this.value.toLowerCase();
      return ['1', 'true'].includes(lowerCase) || !['0', 'false', ''].includes(lowerCase);
    }

    public array() {
      if (this.value === '') return [];
      return this.value
        .replace(/[[\]]/g, '')
        .split(',')
        .map((s) => s.trim());
    }

    public object<R = unknown>() {
      try {
        return JSON.parse(this.value) as R;
      } catch {
        return '';
      }
    }
  };

  public static get(key: string) {
    const allKeys = this.search().getAll(key);

    switch (allKeys.length) {
      case 0:
        return new this.Converter('');
      case 1:
        return new this.Converter(allKeys[0]);
      default:
        return new this.Converter(allKeys[0]);
    }
  }

  public static has(key: string) {
    return this.search().has(key);
  }
}
